export default __webpack_public_path__ + "static/media/heliport_pale.f3530308.svg";